import {
  Descriptions,
  Divider,
  Image,
  Spin,
  Table,
  TableColumnsType,
} from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import { CURRENCY } from "../../enumerations/currencyEnum";
import localStorageKey from "../../enumerations/localStorageKey";
import { useGetOrderDetail } from "../../hooks/OrderReceipt/usercenter.hooks";
import { moneyFormat } from "../../plugins/numberFormat";
import styles from "./style.module.scss";
import "./style.scss";
const OrderReceipt = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [hasTaxId, setHasTaxId] = useState(true);
  const [hasCompanyTitle, setHasCompanyTitle] = useState(true);
  const { data, isPending } = useGetOrderDetail(
    { order_number: searchParams.get("id") },
    { enabled: !!searchParams.get("id") }
  );

  const typeRender = (netVolume: any, type: number) => {
    if (netVolume === -1) return t(`normal.network.type1`);
    // type 0 daily, 1 total
    return t(`normal.network.type${type}`);
  };

  const renderProductName = (optionData: any) => {
    return `${
      optionData?.network_volume === -1
        ? t("normal.network.no.limit")
        : `${optionData?.network_volume}GB`
    } /
    ${t("normal.days", { days: optionData?.days })} /
    ${typeRender(optionData?.network_volume, optionData?.type)}`;
  };
  const localLang = window.localStorage
    .getItem(localStorageKey.DEFAULT_LANG)
    ?.replace(/-/gm, "_");
  useEffect(() => {
    if (data) {
      if (!data?.tax_id_number) setHasTaxId(false);
      if (!data?.company_title) setHasCompanyTitle(false);
    }
  }, [data]);

  const items: any["items"] = [
    {
      key: "order_number",
      label: t("orderInquiry.order.id"),
      children: data?.order_number,
    },
    {
      key: "created_at",
      label: t("orderInquiry.order.date"),
      children: data?.created_at,
    },
    // {
    //   key: "name",
    //   label: t("normal.order.user.name"),
    //   children: data?.name,
    // },
    {
      key: "company_title",
      label: t("normal.buyer"),
      children: data?.company_title,
      hide: !hasCompanyTitle,
    },
    {
      key: "tax_id_number",
      label: t("normal.uniformNumber"),
      children: data?.tax_id_number,
      hide: !hasTaxId,
      // hide: !hasCompanyTitle,
    },
  ];
  const tableColumns: TableColumnsType<any> = [
    {
      title: t("normal.product.name"),
      dataIndex: `product_name_${localLang}`,
      align: "left",
      key: "product_name",
    },
    {
      title: t("normal.type"),
      dataIndex: "network_volume",
      align: "center",
      key: "network_volume",
      render: (value, record) => <span>{renderProductName(record)}</span>,
    },
    {
      title: t("cart.unitPrice"),
      dataIndex: "sell_price",
      align: "center",
      key: "sell_price",
      render: (value) => (
        <span>
          {CURRENCY.TW} {moneyFormat(value)}
        </span>
      ),
    },
    {
      title: t("normal.quantity"),
      dataIndex: "quantity",
      align: "center",
      key: "quantity",
    },
    {
      title: t("cart.subtotal"),
      dataIndex: "total_price",
      align: "center",
      key: "total_price",
      render: (value) => (
        <span>
          {CURRENCY.TW} {moneyFormat(value)}
        </span>
      ),
    },
  ];
  useEffect(() => {
    if (data) {
      console.log("data", data);
    }
  }, [data]);

  const DISCOUNT_REFUND =
    data?.coupon_discount_price +
    data?.referral_discount_price +
    data?.gift_point_discount_price +
    data?.store_discount_price;

  return (
    <Spin spinning={isPending}>
      <div className={styles.orderReceipt}>
        <div className={styles.top}>
          <img
            src={`/images/brands/${process.env.REACT_APP_PROD_NAME_DEV}/header_logo.png`}
            className={styles.logo}
            // preview={false}
            alt="logo"
          />
          <div className={styles.topTitle}>
            {t("orderInquiry.receiptTitle")}
          </div>
        </div>
        {data && (
          <>
            <Descriptions
              items={items.filter((_menu: any) => !_menu.hide)}
              className={`${styles.descriptions} order-detail-description`}
              column={2}
            />
            <Table
              columns={tableColumns}
              dataSource={data?.detail}
              pagination={false}
              className={`${styles.tableContainer} order-detail-table`}
            />
            <div className={styles.conclusion}>
              {/* FIXME: calculate method must use bigjs */}
              <div className={styles.listItem}>
                {`${t("normal.product.total.amount")}: ${
                  CURRENCY.TW
                } ${moneyFormat(data?.total_price)}`}
                {data?.gift_point_discount_price > 0 ? (
                  <span>
                    {`${t("giftpoint.discount")}:  `}
                    <span style={{ color: "var(--pink)" }}>
                      -{CURRENCY.TW}
                      {moneyFormat(data?.gift_point_discount_price)}
                    </span>
                  </span>
                ) : data?.coupon_discount_price +
                    data?.referral_discount_price >
                  0 ? (
                  <span>
                    {`${t("normal.promotion.discount")}:  `}
                    <span style={{ color: "var(--pink)" }}>
                      -{CURRENCY.TW}
                      {moneyFormat(
                        data?.coupon_discount_price +
                          data?.referral_discount_price
                      )}
                    </span>
                  </span>
                ) : (
                  ""
                )}
                {data.pay_status === 3 || data.pay_status === 5 ? (
                  <>
                    <span>
                      {`${t("normal.total.payment.amount")}: `}
                      <span>
                        {CURRENCY.TW} {moneyFormat(data?.sell_price)}
                      </span>
                    </span>
                    {/* <span>
                      {`${t("orderReceipt.cancellationFee")}:  `}
                      <span style={{ color: "var(--pink)" }}>
                        -{CURRENCY.TW}
                        {moneyFormat(data?.return_fee + DISCOUNT_REFUND)}
                      </span>
                    </span> */}

                    <span>
                      {`${t("normal.refund")}:  `}
                      <span style={{ color: "var(--pink)" }}>
                        -{CURRENCY.TW}
                        {moneyFormat(data?.refund_amount)}
                      </span>
                    </span>
                  </>
                ) : (
                  ""
                )}
              </div>
              <div className={styles.listItem}></div>
              <Divider style={{ margin: "0 0 20px 0" }} />
              {data.pay_status === 3 || data.pay_status === 5 ? (
                <div className={styles.listItem}>
                  <span>
                    {`${t("orderReceipt.actualPayment")}: `}
                    <span>
                      {CURRENCY.TW}{" "}
                      {moneyFormat(data?.sell_price - data?.refund_amount)}
                    </span>
                  </span>
                </div>
              ) : (
                <div className={styles.listItem}>
                  <span>
                    {`${t("normal.total.payment.amount")}: `}
                    <span>
                      {CURRENCY.TW} {moneyFormat(data?.sell_price)}
                    </span>
                  </span>
                </div>
              )}
              <div className={styles.invoiceDescArea}>
                <div
                  dangerouslySetInnerHTML={{
                    __html: t("orderInquiry.invoiceDesc"),
                  }}
                />

                <Image
                  alt={`${process.env.REACT_APP_PROD_NAME_DISPLAY}-stamp`}
                  src={`/images/brands/${process.env.REACT_APP_PROD_NAME_DEV}/2esim_stamp.png`}
                  preview={false}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </Spin>
  );
};

export default OrderReceipt;
